var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { saveAppShellData, appShellComponentName } from '../AppShell/utils';
import { autoResolveDynamicData, setLanguage } from '../DynamicData';
import { resolveThemeContext } from '../resolve-component';
import { exposeScopeState } from '../events';
import { initialRenderDone } from '../CurrentPage/is-initial-render';
import ErrorBoundary from './ErrorBoundary';
export const scopeSiteContainerAttribute = 'avensia-scope-root';
export default function browserRender(store, container, element, appInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        exposeScopeState(store);
        if (store.getState().appShellData.pageIsInEditMode) {
            window.IS_IN_EDIT_MODE = true;
        }
        yield (store.getState().currentTheme ? resolveThemeContext(store.getState().currentTheme) : Promise.resolve(null));
        container.setAttribute(scopeSiteContainerAttribute, 'true');
        element = React.createElement(ErrorBoundary, null, element);
        setLanguage(store.getState().appShellData.culture);
        // I'd prefer if we did this after rendering, but the rendering might trigger Dynamic Data
        // resolves and if rendering takes more time than the batch size we risk firing many
        // Dynamic Data requests
        if (appInfo && appInfo.isApp && !appInfo.isPrimaryTab) {
            // If this is a secondary app window, we want to try hitting the cache first,
            // as there is a big chance that the data is already there, from the main window.
            autoResolveDynamicData([store.getState().appShellData], undefined, true);
            // As for the current page, it is unlikely that the main window has the data,
            // so we will just try to resolve it normally.
            autoResolveDynamicData([store.getState().currentPage]);
        }
        else {
            autoResolveDynamicData([store.getState().currentPage, store.getState().appShellData]);
        }
        yield new Promise(resolve => {
            if (window.IS_SERVER_SIDE_RENDERED &&
                store.getState().appShellData.guessedBreakpoint === store.getState().currentBreakpoint) {
                ReactDOM.hydrate(element, container, resolve);
            }
            else {
                ReactDOM.render(element, container, resolve);
            }
        });
        yield saveAppShellData(store.getState().appShellData);
        // If the component name is appshelldata, the render is from SW and we will re-render
        // when we get the real component.
        if (store.getState().currentPage.componentName !== appShellComponentName) {
            initialRenderDone();
        }
    });
}
export function enableSeparateAssetsHost() {
    const webPackPublicPath = window.WEBPACK_ASSETS_HOST;
    if (webPackPublicPath) {
        __webpack_public_path__ = '//' + webPackPublicPath + '/';
    }
}
